<template>
  <div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
      <div :class="'relative  pt-[80px] pb-[80px]  grid items-center p-4 w-full h-full md:h-[100vh] ' + (size ? size : 'max-w-5xl')">
          <div class="relative rounded-xl shadow bg-theme-modalbg h-max max-h-[calc(100vh-100px)] overflow-y-auto">
            <slot name="maincontent"></slot>
          </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "CustomModal",
  components: {
  },
  props: {
    size: {
      required: false,
      type: String,
    }
  },
  setup() {
  
  },
});
</script>

<style>
.custom-modal-wrap:before {
  content: '';
  position: fixed;
  top: 0;
  width: 0;
  height: 100%;
  width: 100%;
  background: rgb(0 0 0 / 64%);
}
</style>
